import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { getDeviceTopInfo } from '@/serviceApi/cloud.common'
import { getAllDeviceList, getNoticeMessageList } from '@/serviceApi/common'
import { useGetResetting } from '@/serviceApi/hems'
import { isEmpty } from "@/tools"
import { initSSE } from '@/tools/sse'
import {
  saveNeuronList,
  saveHandingDeviceList,
  saveBindDeviceResult,
  saveRealTimeNotice,
  saveDeviceControlSettingResult,
  saveDeviceOperationResult,
  saveDeviceControlDefaultSettings,
  saveHistoryNewsList,
  saveOtaInfo,
  saveOtaUpdateResult
} from '@/store/reducer/global';
import arrayToTree from 'array-to-tree';
import { saveDeviceRealTimeData } from '@/store/reducer/home';
import { getApiPath } from '@/tools/apiPath';



export default() => {
  const dispatch = useDispatch()
  const neuronList = useSelector((state: any) => {
    return state.globalData.neuronList
  })
  const userInfo = useSelector((state: any) => {
    return state.globalData.userInfo
  })

  const [runCount, setRunCount] = useState(0)

  // 获取消息通知列表
  const getNewsList = async() => {
    const res = await getNoticeMessageList({
      pageNum: 1,
      pageSize: 10,
    });
    if(res.code === 200) {
      dispatch(saveHistoryNewsList({
        data: res.data.rows,
        success: res.data.success,
        total: res.data.total,
      }))
    }
  }

  // 获取下挂设备
  const checkHandingDevice = async (deviceSn: string) => {
    const res = await getAllDeviceList()
    if (res.code === 200) {
      let data = arrayToTree(res.data, {
        parentProperty: 'upperDeviceSn',
        customID: 'deviceSn'
      }) || []
      dispatch(saveHandingDeviceList( data.filter(((item: any) => item?.deviceSn === deviceSn))))
    }
  }


  // 获取设备控制设置信息
  const getDeviceControlDefaultInfo = async (deviceSn: string) => {
    const res = await useGetResetting({ 
      deviceSn
    })
    if (res.code === 200) {
      dispatch(saveDeviceControlDefaultSettings(res.data))
    }
  }


  useEffect(() => {
    if(isEmpty(userInfo)) return
    if(!isEmpty(userInfo) && runCount !== 0) return
     // 处理页面刷新设备信息丢失
    if(!neuronList) {
      (async () => {
        try{
          const res: any = await getDeviceTopInfo({ deviceType: 4 })
          if(!isEmpty(res.data)) {
            dispatch(saveNeuronList(res.data))
            await checkHandingDevice(res.data?.[0].deviceSn)
            await getDeviceControlDefaultInfo(res.data?.[0].deviceSn)
            await getNewsList()
          }
        } catch {
        }
       
      })()
    }

  //   let data  = {
  //     "evDatas": [
  //         {
  //             "id": 1876449838761705500,
  //             "deviceSn": "SN07889678821",
  //             "deviceType": 6,
  //             "status": 1,
  //             "state": 1,
  //             "enable": 1,
  //             "online": 1,
  //             "volt": 232.15839091697714,
  //             "chargeDurationSecond": 0,
  //             "chargePowerConsumed": 0,
  //             "current": 0,
  //             "powerInit": 0,
  //             "powerCorr": 0
  //         },
  //         {
  //             "id": 1876449838761705500,
  //             "deviceSn": "SN07889670009",
  //             "deviceType": 6,
  //             "status": 1,
  //             "state": 3,
  //             "enable": 1,
  //             "online": 1,
  //             "volt": 232.44448073304775,
  //             "chargeDurationSecond": 5011,
  //             "chargePowerConsumed": 2.78,
  //             "current": 23.71,
  //             "powerInit": 5.512195127112468,
  //             "powerCorr": 5.512195127112468
  //         }
  //     ],
  //     "evCount": 2,
  //     "gridDatas": [
  //         {
  //             "id": 1,
  //             "deviceType": 1,
  //             "status": 1,
  //             "enable": 1,
  //             "online": 1,
  //             "load": 46,
  //             "direction": 0,
  //             "phase": 3,
  //             "voltR": 232.12,
  //             "voltS": 232.12,
  //             "voltT": 232.12,
  //             "currentR": 14.8,
  //             "currentS": 14.8,
  //             "currentT": 14.8,
  //             "powerInit": 3.44,
  //             "powerCorr": 3.44
  //         }
  //     ],
  //     "gridCount": 1,
  //     "pvDatas": [
  //         {
  //             "id": 7,
  //             "deviceType": 5,
  //             "status": 1,
  //             "enable": 1,
  //             "online": 1,
  //             "volt": 400.4540192663917,
  //             "current": 5.23,
  //             "powerInit": 2.09,
  //             "powerCorr": 2.09
  //         },
  //         {
  //             "id": 8,
  //             "deviceType": 5,
  //             "status": 1,
  //             "enable": 1,
  //             "online": 1,
  //             "volt": 400.33463510647414,
  //             "current": 6.39,
  //             "powerInit": 2.56,
  //             "powerCorr": 2.56
  //         }
  //     ],
  //     "pvCount": 2,
  //     "batDatas": [
  //         {
  //             "id": 2,
  //             "deviceType": 2,
  //             "enable": 1,
  //             "online": 1,
  //             "direction": 2,
  //             "volt": 54.126734268415554,
  //             "current": 0,
  //             "powerInit": 0,
  //             "powerCorr": 0,
  //             "totalCapacity": 52,
  //             "SOC": 22,
  //             "SOH": 100,
  //             "temp": 22.42,
  //             "minTemp": 30,
  //             "mixTemp": 7
  //         }
  //     ],
  //     "batCount": 1,
  //     "flDatas": [
  //         {
  //             "id": 3,
  //             "deviceType": 3,
  //             "status": 1,
  //             "enable": 1,
  //             "online": 1,
  //             "phase": 3,
  //             "voltS": 232.27305673547852,
  //             "voltT": 232.27305673547852,
  //             "voltR": 232.27305673547852,
  //             "currentR": 6.68,
  //             "currentS": 6.68,
  //             "currentT": 6.68,
  //             "powerInit": 1.5525171687311468,
  //             "powerCorr": 1.5525171687311468
  //         }
  //     ],
  //     "flCount": 1,
  //     "clDatas": [
  //         {
  //             "id": 4,
  //             "deviceType": 4,
  //             "status": 1,
  //             "enable": 1,
  //             "online": 1,
  //             "phase": 3,
  //             "voltS": 232.34893533747848,
  //             "voltT": 232.34893533747848,
  //             "voltR": 232.34893533747848,
  //             "currentR": 4.41,
  //             "currentS": 4.41,
  //             "currentT": 4.41,
  //             "powerInit": 1.0256544094682556,
  //             "powerCorr": 1.0256544094682556
  //         }
  //     ],
  //     "clCount": 1
  // };
  // dispatch(saveDeviceRealTimeData(data));
    
    // 订阅sse推送
    // let data = JSON.parse("{\"gridDatas\":[{\"id\":1,\"deviceType\":1,\"enable\":1,\"load\":-1,\"online\":1,\"direction\":2,\"phase\":3,\"voltR\":0,\"currentR\":0,\"powerInit\":-1,\"powerCorr\":-1,\"status\":-1}],\"gridCount\":1,\"clDatas\":[{\"id\":1,\"deviceType\":4,\"enable\":1,\"online\":1,\"phase\":3,\"voltR\":231,\"currentR\":0,\"powerInit\":-1,\"powerCorr\":-1,\"status\":-1}],\"clCount\":1,\"flDatas\":[{\"id\":2,\"deviceType\":3,\"enable\":1,\"online\":1,\"phase\":3,\"voltR\":0,\"currentR\":0,\"powerInit\":-1,\"powerCorr\":-1,\"status\":-1}],\"flCount\":1,\"batDatas\":[{\"id\":1,\"deviceType\":2,\"enable\":1,\"online\":1,\"direction\":2,\"volt\":52,\"current\":0,\"powerInit\":0,\"powerCorr\":-1,\"totalCapacity\":4294967,\"SOC\":48,\"SOH\":-1,\"temp\":-1,\"maxTemp\":-1,\"minTemp\":-1,\"status\":-1}],\"batCount\":1,\"pvDatas\":[{\"id\":1,\"deviceType\":5,\"enable\":1,\"online\":0,\"volt\":0,\"current\":0,\"powerInit\":0,\"powerCorr\":-1,\"status\":-1},{\"id\":2,\"deviceType\":5,\"enable\":1,\"online\":0,\"volt\":0,\"current\":0,\"powerInit\":0,\"powerCorr\":-1,\"status\":-1}],\"pvCount\":2,\"evDatas\":[],\"evCount\":0}")
    // dispatch(saveDeviceRealTimeData(data))

    // 设置项提交，包括通知设置
    // {"action":"TERMINAL_UPDATE_SETTING_RESULT:txNpkQwh-1732591434","data":"{\"isUpdate\":false,\"notSyncSetting\":[\"notice\"]}"}
    // //47.121.136.99
    
    // dispatch(saveOtaInfo({
    //   "type": "reportDownload",
    //   "params": {
    //     "completeRatio": 50,//下载进度百分比
    //     "downloadMode": "HTTP",//下载方式 "Http"
    //     "resultCode": "1232131",//当前状态 0：正常，1：异常
    //     "resultMsg": "正在准备更新"//详细信息
    //   }
    // }));

    // dispatch(saveOtaInfo({
    //     "type":"reportInstall",
    //     "params":{
    //         "installState":1,//安装过程 0：开始，1：完成，2：失败
    //         "resultCode":"1232131",//当前状态 0：正常，1：异常
    //         "resultMsg":"正在准备更新"//详细信息
    //     }
    //    })
    // );

    //  dispatch(saveOtaUpdateResult({
    //       "isUpdateSucess":false,//是否更新成功
    //       "updateBeforeVersion":"1.0.1",//更新之前的版本
    //       "updateAfterVersion":"1.1.1"//更新之后的版本
    //  })
    //   );


    // const a  = {"action":"TERMINAL_OTA_RESULT:WKRD24070202100268U","data":"{\"isUpdateSucess\":false,\"updateBeforeVersion\":\"1.2.0\",\"updateAfterVersion\":\"1.2.0\",\"versionId\":\"1923319802743619586\"}"}
    // dispatch(saveOtaUpdateResult({
    //   neuron: a.action.split(':')[1],
    //   data: JSON.stringify(a.data)
    // }));

    initSSE({
      url: getApiPath('/resource/sse'),
      //url: `/prod-api/resource/sse`,
      callback(type, event) {
          if(type === 'MESSAGE') {
              // 登录成功推送
              if(event.action.includes('LOGIN_NOTICE')) {
                 
              }

              // 首页实时数据
              if(event.action.includes('TERMINAL_REAL_TIME_DATA')) {
                console.log('实时数据:::', JSON.parse(event.data))
                dispatch(saveDeviceRealTimeData(JSON.parse(event.data)))
              }

              // 绑定设备结果
              if(event.action.includes('TERMINAL_DEVICE_BINDING')) {
                dispatch(saveBindDeviceResult(JSON.parse(event.data)))
              }

               // 通知消息推送
              if(event.action.includes('MESSAGE_NOTICE')) {
                 dispatch(saveRealTimeNotice(JSON.parse(event.data)))
              }

              // 设置页面提交设置成功结果
              if(event.action.indexOf('TERMINAL_UPDATE_SETTING_RESULT') > -1) {
                  dispatch(saveDeviceControlSettingResult(JSON.parse(event.data)))
              }

              // 设备管理操作结果反馈
              if(event.action.indexOf('TERMINAL_OPERATION') > -1) {
                  dispatch(saveDeviceOperationResult(JSON.parse(event.data)))
              }
            
            
            // ota更新进度过程
            if(event.action.includes('TERMINAL_OTA_PROGRESS')) {
              const data = JSON.parse(event.data)
              dispatch(saveOtaInfo({
                  type: data.type,
                  params: JSON.parse(data.params)
              }));
            }

            // ota更新结果
            if(event.action.includes('TERMINAL_OTA_RESULT')) {
              dispatch(saveOtaUpdateResult({
                neuron: event.action.split(':')[1],
                data: JSON.stringify(JSON.parse(event.data))
              }));
            }

          }
      }
    })
  }, [runCount, userInfo])
  

}
